/* eslint-disable no-restricted-globals */
import { langCode } from '@ott/l10n';

const DEPTH = {
  1: 'ONE_BIT',
  4: 'FOUR_BITS',
  8: 'EIGHT_BITS',
  15: 'FIFTEEN_BITS',
  16: 'SIXTEEN_BITS',
  24: 'TWENTY_FOUR_BITS',
  32: 'THIRTY_TWO_BITS',
  48: 'FORTY_EIGHT_BITS',
};

export default function getDefaultBrowserData() {
  return {
    timezone: Math.abs(new Date().getTimezoneOffset()).toString(),
    language: langCode === 'ru' ? 'RU' : 'EN',
    colorDepth: DEPTH[window.screen.colorDepth] || 'THIRTY_TWO_BITS',
    windowHeight: window.outerHeight,
    windowWidth: window.outerWidth,
    screenHeight: screen.height,
    screenWidth: screen.width,
    userAgent: navigator.userAgent,
    javaEnabled: true,
  };
}
